var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketEms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99163 24.2749C7.60568 23.9084 7.00021 23.9084 6.61426 24.2749L0.313326 30.2598C-0.341664 30.8819 0.0986516 31.9848 1.00201 31.9848H2.38296V45.1729C2.38296 45.7252 2.83067 46.1729 3.38296 46.1729H11.223C11.7753 46.1729 12.223 45.7252 12.223 45.1729V31.9848H13.6039C14.5072 31.9848 14.9476 30.8819 14.2926 30.2598L7.99163 24.2749Z",
    fill: "#E9E9E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8926 16.1218C42.7048 15.9594 42.4263 15.9594 42.2385 16.1218L37.174 20.5013C36.8236 20.8043 37.0379 21.3795 37.501 21.3795H38.9858V29.5902C38.9858 29.8663 39.2097 30.0902 39.4858 30.0902H45.6455C45.9216 30.0902 46.1455 29.8663 46.1455 29.5902V21.3795H47.63C48.0931 21.3795 48.3074 20.8043 47.9571 20.5013L42.8926 16.1218Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1888 0.654091C25.8029 0.287503 25.1974 0.287504 24.8115 0.654091L13.8929 11.0249C13.2379 11.647 13.6782 12.75 14.5816 12.75H18.0001V39C18.0001 39.5522 18.4479 40 19.0001 40H32.0001C32.5524 40 33.0001 39.5522 33.0001 39V12.75H36.4187C37.322 12.75 37.7624 11.647 37.1074 11.0249L26.1888 0.654091Z",
    fill: "#246FE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketEms);
export default __webpack_public_path__ + "static/media/market_ems.2408b25fc36aa8b11cb635b449e11799.svg";
export { ForwardRef as ReactComponent };